import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfflineDialogComponent } from './offline-dialog.component';
import { MaterialModule } from '@app/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [OfflineDialogComponent],
  imports: [CommonModule, MaterialModule, FlexLayoutModule, TranslateModule],
  exports: [OfflineDialogComponent],
})
export class OfflineDialogModule {}
